<template>
  <v-container class="pa-0">
    <v-row class="pa-5">
      <v-col cols="12" class="pb-0">
        <v-autocomplete
          :search-input.sync="search"
          label="Customer Number"
          :items="items"
          outlined
          v-model="customerNumber"
          placeholder=" "
          @change="checkForm"
        ></v-autocomplete>
      </v-col>

      <v-col cols="12" sm="12" md="6" class="pt-0 pb-0">
        <v-dialog
          ref="startDateDialog"
          v-model="startDateModal"
          :return-value.sync="startDate"
          persistent
          width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              prepend-inner-icon="event"
              readonly
              v-on="on"
              placeholder="Start Date"
              outlined
              @change="checkForm"
              :value="dateFormat(startDate)"
            ></v-text-field>
          </template>
          <v-date-picker v-model="startDate" scrollable>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="startDateModal = false"
              >Cancel</v-btn
            >
            <v-btn
              color="primary"
              @click="$refs.startDateDialog.save(startDate)"
              >OK</v-btn
            >
          </v-date-picker>
        </v-dialog>
      </v-col>

      <v-col cols="12" sm="12" md="6" class="pt-0 pb-0">
        <v-dialog
          ref="endDateDialog"
          v-model="endDateModal"
          :return-value.sync="endDate"
          persistent
          width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              prepend-inner-icon="event"
              readonly
              v-on="on"
              placeholder="End Date"
              outlined
              @change="checkForm"
              :value="dateFormat(endDate)"
            ></v-text-field>
          </template>
          <v-date-picker v-model="endDate" scrollable>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="endDateModal = false"
              >Cancel</v-btn
            >
            <v-btn color="primary" @click="$refs.endDateDialog.save(endDate)"
              >OK</v-btn
            >
          </v-date-picker>
        </v-dialog>
      </v-col>

      <v-col cols="12" class="pt-0 pb-0">
        <v-text-field
          name="note"
          label="Note"
          id="note"
          v-model="note"
          outlined
          class="dispute-note"
        ></v-text-field>
      </v-col>

      <v-col cols="12" class="pt-0 pb-0 text-right">
        <v-btn
          color="primary"
          @click="loadData(customerNumber)"
          :disabled="completed"
          >Get Services</v-btn
        >
        <v-btn
          color="primary"
          @click="sendCalcs(response)"
          class="ml-5"
          v-if="hasResponse"
          >Push Log</v-btn
        >
      </v-col>

      <v-col cols="12" class="pt-0 pb-0 mt-10">
        <v-data-table
          :headers="headers"
          :items="response"
          :items-per-page="5"
          class="elevation-1"
          v-if="hasResponse"
        >
          <template v-slot:item.credit="{ value, item }"
            >${{ item.credit }}</template
          >
        </v-data-table>
      </v-col>

      <v-col cols="12 mt-5" class="total-credits" v-if="hasResponse"
        >Total: ${{ total }}</v-col
      >

      <existing-services
        :dialog="dialog"
        @close="dialog = false"
        @calculate="showCalcs"
        ref="existing"
      ></existing-services>

      <v-dialog v-model="disputeDialog" persistent width="300">
        <v-card color="primary" dark class="pt-4">
          <v-card-text>
            Processing dispute. Please wait...
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="testDialog" max-width="500" persistent>
        <v-card>
          <v-card-title class="headline">Mock Logs</v-card-title>

          <v-card-text>
            <p v-for="(res, i) in testResponse" :key="i" class="mb-0">
              {{ res }}
            </p>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="testDialogRefresh"
              >Close</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-snackbar
        v-model="disputeAlert"
        :bottom="y === 'bottom'"
        color="success"
        :timeout="4000"
        :top="y === 'top'"
        :vertical="mode === 'vertical'"
      >
        Dispute request sent successfully!
        <v-btn dark text @click="disputeAlert = false">Close</v-btn>
      </v-snackbar>
    </v-row>
  </v-container>
</template>

<script>
import ExistingServices from "@/components/dialogs/existing-services-dialog";
import { mapActions } from "vuex";
export default {
  name: "DisputeView",
  components: {
    ExistingServices,
  },
  data() {
    return {
      headers: [
        { text: "Service", value: "service", sortable: false },
        { text: "Start Date", value: "startDate", sortable: false },
        { text: "End Date", value: "endDate", sortable: false },
        { text: "Credit", value: "credit", sortable: false },
      ],
      desserts: [],
      dialog: false,
      isLoading: false,
      search: null,
      items: [],
      ticketID: null,
      startDate: null,
      endDate: null,
      customerNumber: null,
      response: null,
      note: null,
      startDateModal: false,
      endDateModal: false,
      date: new Date().toISOString().substr(0, 10),
      hasResponse: false,
      total: 0,
      logString: [],
      disputeAlert: false,
      disputeDialog: false,
      y: null,
      mode: null,
      testDialog: false,
      testResponse: [],
    };
  },
  computed: {
    completed() {
      return !this.customerNumber || !this.startDate || !this.endDate
        ? true
        : false;
    },
  },
  filters: {
    currency(val) {
      return `$${val}`;
    },
  },
  methods: {
    ...mapActions("reminders", [
      "RetrieveCustomer",
      "RequestCustomerDispute",
      "SendCustomerDispute",
    ]),
    checkForm() {
      if (!this.customerNumber) {
        this.error = true;
      }
    },
    loadData(event) {
      this.dialog = true;
      this.$refs.existing.loadServices(event);
    },
    showCalcs(val) {
      this.total = 0;
      this.logString = [];

      this.RequestCustomerDispute({
        startDate: this.startDate,
        endDate: this.endDate,
        customerNumber: this.customerNumber,
        formatResponse: [],
        csn: val.map((x) => x.service),
      }).then((data) => {
        if (this.response !== "") {
          this.hasResponse = true;
          this.response = data.formatResponse;

          this.response.forEach((res) => {
            this.total += res.credit;
            this.logString.push(res.logString);
          });

          this.total = this.total.toFixed(2);
          this.logString.push(this.note);
          this.logString.push(`Total: $${this.total}`);
        }
      });
    },
    testDialogRefresh() {
      this.customerNumber = null;
      this.items = [];
      this.startDate = null;
      this.endDate = null;
      this.response = [];
      this.hasResponse = false;
      this.note = null;
      this.$refs.existing.resetServices();
      this.total = 0;
      this.testDialog = false;
      this.testResponse = [];
    },
    sendCalcs(val) {
      let packet = {
        ticketID: "22232323",
        data: {
          startDate: this.startDate,
          endDate: this.endDate,
          customerNumber: this.customerNumber,
          logString: this.logString,
          csn: val.map((x) => x.service),
        },
      };

      this.disputeDialog = true;
      this.testResponse = packet.data.logString;
      this.disputeDialog = false;
      this.disputeAlert = true;
      this.testDialog = true;
      // this.SendCustomerDispute(packet).then(data => {
      // 	this.response = data.formatResponse;
      // 	this.disputeDialog = false;
      // 	this.disputeAlert = true;
      // });

      // this.customerNumber = null;
      // this.items = [];
      // this.startDate = null;
      // this.endDate = null;
      // this.response = [];
      // this.hasResponse = false;
      // this.note = null;
      // this.$refs.existing.resetServices();
      // this.total = 0;
    },
    dateFormat(date) {
      if (!date) return "";

      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [day, month, year].join("-");
    },
  },
  watch: {
    search(val) {
      this.isLoading = true;

      this.RetrieveCustomer(val)
        .then((res) => {
          this.items = res;
        })
        .catch((err) => {})
        .finally(() => (this.isLoading = false));
    },
  },
};
</script>

<style lang="scss" scoped>
.services-list-tbl tr:last-child {
  background: transparent !important;
}
.total-credits {
  font-weight: bold;
  font-size: 2rem;
}
</style>